import { ThemeColors } from "@insite/mobius/globals/baseTheme";
import { safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const fontFamily = "'Montserrat', sans-serif";

export const mediaQueriesBP = {
    maxSM: "@media screen and (max-width: 424px)",
    minSM: "@media screen and (min-width: 425px)",

    maxMD: "@media screen and (max-width: 767px)",
    minMD: "@media screen and (min-width: 768px)",

    maxLG: "@media screen and (max-width: 1023px)",
    minLG: "@media screen and (min-width: 1024px)",

    maxXLG: "@media screen and (max-width: 1199px)",
    minXLG: "@media screen and (min-width: 1200px)",

    minMDMaxLg: "@media screen and (min-width: 768px) and (max-width: 1023px)",
};

export const calcInitial = "calc((((100vw - (100vw - var(--width, 0))) - 100%) / 2) * -1)";

export const gutter = 15;

export const colorPalette: RecursivePartial<ThemeColors> = {
    primary: {
        main: "#002CA1",
    },
    secondary: {
        main: "#001D4D",
    },
    success: {
        main: "#068823",
    },
    danger: {
        main: "#D62700",
    },
    info: {
        main: "#005DD6",
    },
    text: {
        main: "#001D4D",
    },
    warning: {
        main: "#FFB800",
    },
    common: {
        background: "#fff",
        border: "#f0f0f0",
        global: {
            white: "#fff",
            black: "#000",

            // Grays
            gray01: "#435067",
            gray02: "#444444",
            gray03: "#969A9D",
            gray04: "#DBE2E9",
            gray05: "#e5e5e5",
            gray06: "#f0f0f0",

            // UI
            uiGreen: "#008768",
            uiRed: "#D83300",
            uiRedLight: "#FFFAF9",
            uiYellow: "#ffcc00",

            // Client specific colors
            blueLavender: "#E6EDFF",
        },
    } as any,
};

export const colorStrings = {
    primaryMain: "primary.main",
    secondaryMain: "secondary.main",
    successMain: "success.main",
    dangerMain: "danger.main",
    warningMain: "warning.main",
    infoMain: "info.main",
    commonBackground: "common.background",
    commonBorder: "common.border",
    textMain: "text.main",
    textLink: "text.link",
    common: "common",
    commonDisabled: "common.disabled",

    commonGlobalWhite: "common.global.white",
    commonGlobalBlack: "common.global.black",
    commonGlobalGray01: "common.global.gray01",
    commonGlobalGray02: "common.global.gray02",
    commonGlobalGray03: "common.global.gray03",
    commonGlobalGray04: "common.global.gray04",
    commonGlobalGray05: "common.global.gray05",
    commonGlobalGray06: "common.global.gray06",
    commonGlobalUiGreen: "common.global.uiGreen",
    commonGlobalUiRed: "common.global.uiRed",
    commonGlobalUiRedLight: "common.global.uiRedLight",
    commonGlobalUiYellow: "common.global.uiYellow",
    commonGlobalBlueLavender: "common.global.blueLavender",
};

export const manualStyles = {
    headerMobileSelected: css`
        background: #0032a040;
        background: ${safeColor(getColor(colorStrings.primaryMain)).rgb().alpha(0.25).toString()};
        color: #25282a;
        color: ${getColor(colorStrings.textMain)};
    `,
};

export const isWindows = () =>
    (typeof window !== "undefined" && window !== undefined && window.navigator.userAgent
        ? window.navigator.userAgent
        : ""
    ).indexOf("Windows") !== -1;
